/**
 * This file contains validation utilities for form fields.
 */

/**
 * Validates that a string contains only alphanumeric characters
 * @param {string} value The string to validate
 * @returns {boolean} True if the string contains only alphanumeric characters
 */
export function hasNoSpecialCharacters(value) {
  return /^[a-zA-Z0-9\s]*$/.test(value);
}

/**
 * Validates that a string contains only alphanumeric characters and hyphens
 * Used for legal_name field which may contain hyphens (e.g., "A-List Me LLC")
 * @param {string} value The string to validate
 * @returns {boolean} True if the string contains only allowed characters
 */
export function hasNoSpecialCharactersExceptHyphens(value) {
  return /^[a-zA-Z0-9\s-]*$/.test(value);
}

/**
 * Gets the field display name for error messages
 * @param {string} fieldName The field name from the form
 * @returns {string} The display name for the field
 */
export function getFieldDisplayName(fieldName) {
  const displayNames = {
    first_name: 'First Name',
    middle_name: 'Middle Name',
    last_name: 'Last Name',
    legal_name: 'Legal Name',
    company_name: 'Company Name',
    account_name: 'Beneficiary Name on Account',
    address: 'Street Address',
    payment_billing_address: 'Payment Street Address',
    city: 'City',
    payment_city: 'Payment City',
    state: 'State',
    payment_state: 'Payment State',
    zip: 'Zip Code',
    payment_zip: 'Payment Zip Code',
    account_number: 'Account Number',
    routing_number: 'Routing Number',
    reEnterAccountNumber: 'Re-entered Account Number',
    reEnterRoutingNumber: 'Re-entered Routing Number',
    bank_name: 'Bank Name',
  };
  return displayNames[fieldName] || fieldName;
}
